/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M7.5 6a.75.75 0 0 0 0 1.5h9.75a.75.75 0 0 0 0-1.5H7.5ZM6.75 12a.75.75 0 0 1 .75-.75h9.75a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75ZM7.5 15.75a.75.75 0 0 0 0 1.5h5.25a.75.75 0 0 0 0-1.5H7.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.5 3c0-1.6568 1.3432-3 3-3h15c1.6569 0 3 1.3432 3 3v18c0 1.6569-1.3431 3-3 3h-15c-1.6568 0-3-1.3431-3-3V3Zm3-1.5h15c.8284 0 1.5.6716 1.5 1.5v18c0 .8284-.6716 1.5-1.5 1.5h-15c-.8284 0-1.5-.6716-1.5-1.5V3c0-.8284.6716-1.5 1.5-1.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Docs'
);
